/**
 * @generated SignedSource<<bee37059263c423eee9d7231f121006c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type useChatUnreadCountSubscription$variables = Record<PropertyKey, never>;
export type useChatUnreadCountSubscription$data = {
  readonly channelsUnreadCountSubscription: number;
};
export type useChatUnreadCountSubscription = {
  response: useChatUnreadCountSubscription$data;
  variables: useChatUnreadCountSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "channelsUnreadCountSubscription",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useChatUnreadCountSubscription",
    "selections": (v0/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useChatUnreadCountSubscription",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "66a012b8379986f2439897ff8bf02881",
    "id": null,
    "metadata": {},
    "name": "useChatUnreadCountSubscription",
    "operationKind": "subscription",
    "text": "subscription useChatUnreadCountSubscription {\n  channelsUnreadCountSubscription\n}\n"
  }
};
})();

(node as any).hash = "91504dc478a846a9f77107308b2d5773";

export default node;
